export const NOT_ALLOWED_MOBILE_EN = {
  notAllowedMobile: {
    message: 'Our mobile view is currently under construction',
    backToHome: 'Back to Home'
  }
}

export const NOT_ALLOWED_MOBILE_DE = {
  notAllowedMobile: {
    message: 'Unsere mobile Ansicht befindet sich derzeit im Aufbau',
    backToHome: 'Zurück zur Startseite'
  }
}
